export default "__VITE_ASSET__B_eS8F2C__"